import { render, staticRenderFns } from "./dispatchRecordDetail.vue?vue&type=template&id=2e41066a&scoped=true"
import script from "./dispatchRecordDetail.vue?vue&type=script&lang=js"
export * from "./dispatchRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./dispatchRecordDetail.vue?vue&type=style&index=0&id=2e41066a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41066a",
  null
  
)

export default component.exports